import { SignInPageController } from 'pages/SignIn/machine';

export const useUnlockAccountStatus = (): 'success' | 'failed' | null =>
  SignInPageController.useSelector((state) => {
    if (state.context.isUnlockAccount && state.matches('unlocked')) {
      return 'success';
    }
    if (state.matches('unlock.failed')) {
      return 'failed';
    }
    return null;
  });
